// Import Vue Form Validator module
var config = {
    locale: typeof currentWpLocale !== 'undefined' ? currentWpLocale : 'en'
}

if (typeof default_document_format === 'undefined') {
    var default_document_format = "doc";
}

var dynamic_default_document_format = $(".document-format-val").attr('data-format');

if (dynamic_default_document_format != 0) {
    default_document_format = dynamic_default_document_format
}

Vue.use(VeeValidate, config);

var vm = new Vue({
    el: "#document-app",
    data: {
        showForm: false,
        document: {
            format: default_document_format
        }
    },
    methods: {
        handleSubmit(e) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    e.target.submit();
                }
            }).catch(() => {
                return false
            });
        }
    },
    computed: {}
});

/* DOCUMENT DASHBOARD FORM
	___________________________________________________________*/

// Modify document button -> load form

$(document).on('click touch','#document-modify-btn', function (e) {
    var value = $(this).attr("data-document");
    var data = $(value).serialize();
    $('body').addClass('is-loading');

    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&doc_id=' + value + '&action=get_document_form_action',
        success: function (response) {
            var res = JSON.parse(response);
            $('#modify-document-container').empty().append(res);

            $(".select-document-country").select2({
                    ajax: {
                        url: ajaxurl,
                        dataType: 'json',
                        type: 'GET',
                        data: function(term) {
                            return {
                                term : term,
                                action : 'get_country_list_action'
                            }
                        },
                        processResults: function (data) {
                            return {
                                results : data,
                            }
                        }
                    }
                }
            );

            $(".select-document-language").select2({
                    ajax: {
                        url: ajaxurl,
                        dataType: 'json',
                        type: 'GET',
                        data: function(term) {
                            return {
                                term : term,
                                action : 'get_languages_list_action'
                            }
                        },
                        processResults: function (data) {
                            return {
                                results : data,
                            }
                        }
                    }
                }
            );
        }
    }).always(function () {
        $('body').removeClass('is-loading');
    });
    e.preventDefault();
});

$(document).on('click touch','#document-delete-btn', function (e) {

    swal({
        title: ilioSwal.swalDeleteTitle,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f9b616',
        cancelButtonColor: '#ff6c7d',
        confirmButtonText: ilioSwal.swalDeleteConfirm,
        cancelButtonText: ilioSwal.swalDeleteCancel
    }).then((result) => {
        if (result.value) {

            var doc_id = $(this).attr("data-document");
            var ent_id = $(this).attr("data-entity");
            var data_url = $(this).attr("data-url");
            $('body').addClass('is-loading');

            $.ajax({
                'url': ajaxurl,
                'type': 'GET',
                'data': '&doc_id=' + doc_id + '&ent_id=' + ent_id + '&action=delete_document_action',
                success: function (response) {
                    var res = JSON.parse(response);
                    var url = $('#dashboard-document-list-container').attr("data-url");
                    var ent_id = $('#dashboard-document-list-container').attr("data-ent-id");
                    $('#dashboard-document-list-container').load(data_url + " #dashboard-document-list-container>*")

                    swal({
                        title: res.message.title,
                        html: res.message.message,
                        type: res.message.type
                    });

                }
            }).always(function () {
                $('body').removeClass('is-loading');
            });

        }
    });
    e.preventDefault();
});
var loaderImage = "https://loading.io/spinners/dual-ring/lg.dual-ring-loader.gif";

$(document).on("submit",'#loadfromajax_document', function (e) {

    e.preventDefault();

    // ADD LOADER
    var submitBtn = $(this).find(':submit');
   // $(submitBtn).after("<img src='"+loaderImage+"' class='submit-loader-image' />");

    vm.$validator.validateAll().then((result) => {
        if (result) {
            var data = new FormData(this);
            var page_url = $(this).attr('data-url');
            $('body').addClass('is-loading');

            $.ajax({
                'url': ajaxurl,
                'type': 'POST',
                'async': true,
                'processData': false,
                'contentType': false,
                'data': data,
                success: function (response) {
                //    $(".submit-loader-image").fadeOut('fast').remove();

                    var res = JSON.parse(response);
                    // Display message
                    swal({
                        title: res.message.title,
                        html: res.message.message,
                        type: res.message.type
                    }).then((result) => {
                        if (res.message.type == "success") {
                          window.location.href = page_url;
                        }

                    });

                    /*// Load new document
                    var url = $('#dashboard-document-list-container').attr("data-url");
                    var ent_id = $('#dashboard-document-list-container').attr("data-ent-id");
                    $('#dashboard-document-list-container').load(url + "?ent_id=" + ent_id + " #dashboard-document-list-container>*")*/
                }
            }).always(function () {
                $('body').removeClass('is-loading');
            });
        }
    }).catch(() => {
        return false
    });
});




/* DOCUMENT SEARCH
	___________________________________________________________*/

$(document).on('change','#search-documents-orderby', function (e) {
    var data = $('#loadfromajax_document_search').serialize();
    $('body').addClass('is-loading');

    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': data + '&action=get_documents_search_action',
        success: function (response) {
            var res = JSON.parse(response);
            $('#document-search-results').empty().append(res);
        }
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});

$(document).on('click touch','.document-sort', function (e) {
    var data = $('#loadfromajax_document_search').serialize();
    var sort = $(this).attr("data-sort");
    console.log(sort);
    $('body').addClass('is-loading');

    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': data + '&sort=' + sort + '&action=get_documents_search_action',
        success: function (response) {
            var res = JSON.parse(response);
            $('#document-search-results').empty().append(res);
        }
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});

// Modify pagination loaded with ajax ( to give good url )

$(document).on('click touch', '#ajax-documents-pagination a', function(e) {
    e.preventDefault();

    var link = $(this).attr('href');

    var newLink = "";
    if (link.includes("page")) {
        newLink = link.substring(link.indexOf("page"));
    } else if (link.includes("?")) {
        newLink = link.substring(link.indexOf("?"));
    }

    var pageLink = $('#document-search-results').attr("data-url");

    var resultsLink = pageLink + newLink;

    $('#document-search-results').load(resultsLink + " #document-search-results>*", function () {

        function scrolltoTop() {
            var offsetTop = $("#document-search-results").offset().top;
            $('html, body').animate({ scrollTop: offsetTop - 100 }, 500);
        }

        scrolltoTop();
    });


});

var all_placeholder = "";
if (typeof document_placeholder_all !== 'undefined') {
    all_placeholder = document_placeholder_all;
} else {
    all_placeholder = "Tous";
}

var search_placeholder = "";
if (typeof document_placeholder_search !== 'undefined') {
    search_placeholder = document_placeholder_search;
} else {
    search_placeholder = "Recherche";
}

//console.log(document_placeholder_search);
//console.log(search_placeholder);

$(".select-document-country").select2({
    placeholder: all_placeholder,
    allowClear: true,
        ajax: {
            url: ajaxurl,
            dataType: 'json',
            type: 'GET',
            data: function(term) {
                return {
                    term : term,
                    action : 'get_country_list_action'
                }
            },
            processResults: function (data) {
                return {
                    results : data,
                }
            }
        }
    }
);

$("#search-documents-entity_sectors").select2({
        placeholder: all_placeholder,
        allowClear: true,
    multiple: true
    }
);

$(".select-document-language").select2({
    placeholder: search_placeholder,
    allowClear: true,
        ajax: {
            url: ajaxurl,
            dataType: 'json',
            type: 'GET',
            data: function(term) {
                return {
                    term : term,
                    action : 'get_languages_list_action'
                }
            },
            processResults: function (data) {
                return {
                    results : data,
                }
            }
        }
    }
);

// Reinit of search filters

$(document).on("click touch", "#btn-init-filters", function() {

    $('#select-document-country').empty().trigger('change');
    $('#select-document-language').empty().trigger('change');
    $('#search-documents-entity_sectors').empty().trigger('change');

    $('#search-documents-s').removeAttr('value');

    $('#search-documents-type option').removeAttr("selected");

    $('#search-documents-entity_sectors option').removeAttr("selected");


});


$(document).on("click touch", ".full" , function() {
    var post_id = $(this).attr("data-post");
    var stars = $(this).val();
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&stars=' + stars + '&post_id=' + post_id + '&action=add_remove_post_stars',
        success: function (response) {
            // Check all radio buttons with the same id
            var res = JSON.parse(response);

            if (res.success == true) {
                console.log('[data-rating-id="star' + res.stars + '-' + res.id + '"]');
                $('[data-rating-id="star' + res.stars + '-' + res.id + '"]').prop("checked", true);
            }
        }
    });

});


$(document).on('click touch','.SignalDocument', function (e) {
    swal({
        title: ilioSwal.swalSignalDocument,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f9b616',
        cancelButtonColor: '#ff6c7d',
        confirmButtonText: ilioSwal.swalYesConfirm,
        cancelButtonText: ilioSwal.swalDeleteCancel
    }).then((result) => {
        if (result.value) {

            var user_name = $(this).attr("data-user");
            var doc_id = $(this).attr("data-document");
            var user_id = $(this).attr("data-user-id");
            $.ajax({
                'url': ajaxurl,
                'type': 'GET',
                'data': '&user_name=' + user_name + '&doc_id=' + doc_id + '&user_id=' + user_id + '&action=signal_document_mail',
            });
        }
    });

    e.preventDefault();
});


/*var logID = 'log',
    log = $('<div id="'+logID+'"></div>');
$('body').append(log);
$('[type*="radio"]').change(function () {
    var me = $(this);
    log.html(me.attr('value'));
});*/

// Open document modal with document sheet

//$(document).on("click touch", ".open-document-modal" , function() {
//    var modal_id = $(this).attr("data-modal");
//    $("#" + modal_id ).modal('show');
//
//});

$(document).on("click", ".copyToClip", function() {
    $(".document-modal__copy-success").each(function() {
        $(this).hide();
    });

    var target = $(this).attr("data-copy-target");
    copyToClipboard("." + target );

});

function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    try {
        var successful = document.execCommand('copy');
        if (successful) {
            $(element).nextAll(".document-modal__btn").find(".document-modal__copy-success").show();
        }
    } catch (err) {
    }
    $temp.remove();

}

// Multiple select of documents to share


$(document).on("submit",'#documents-share-form', function (e) {
    $("#document-link-form .document-modal__link").empty();

    $(".document-share-error").hide();

    var data = $(this).serialize();

    if ($('input[name="documents[]"]:checked').length) {

        $('body').addClass('is-loading');

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': false,
            'processData': false,
            'contentType': false,
            'data': data + '&action=documents_share_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#document-link-form').modal('show');
                $("#document-link-form .document-modal__link").html(res.link);

            }
        }).always(function () {
            $('body').removeClass('is-loading');
        });
    } else {
        $(".document-share-error").show();
    }


    e.preventDefault();
});
